import React, { useEffect, useState } from "react";
import Layout from "../../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../../elements/list/list";
import { Container } from "../../../common/layout/styels";
import ViewFiles from "../../documents/ViewFiles";
import { useSelector } from "react-redux";
import { getData } from "../../../../../backend/api";
// import NationalityChart from "./chart";
const EquipmentReport = (props) => {
  const { t } = useTranslation();

  const user = useSelector((state)=> state.login)

  const [userCountNation, setUserCountNation] = useState([]);

  const [attributes] = useState([
      {
        type: "select",
        placeholder: "documentType",
        name: "documentType",
        validation: "",
        showItem: "locale",
        default: "",
        label: "documentType",
        required: true,
        view: true,
        add: true,
        update: true,
        apiType: "API",
        selectApi: "document-type/select",
        filter: false,
      },
      {
        type: "select",
        placeholder: "select",
        name: "folderType",
        validation: "",
        showItem: "locale",
        default: "",
        label: "folderTypes",
        required: false,
        view: false,
        add: true,
        update: true,
        apiType: "API",
        selectApi: "folder-type/select",
        filter: false
      },
      {
        type: "expired",
        placeholder: "status",
        tab: "generalInfo",
        name: "expiryDate",
        validation: "",
        collection: "",
        showItem: "expiryDate",
        default: "",
        value: "Active",
        ifNull: "Active",
        label: "status",
        required: false,
        view: true,
        tag: true,
        add: false,
        update: true,
        filter: false,
      },
      {
        type: "date",
        placeholder: "expiryDate",
        name: "expiryDate",
        validation: "date",
        default: "empty",
        label: "expiryDate",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
        filter: false,
      },
      {
        type: "select",
        placeholder: "visibility",
        name: "visibility",
        validation: "",
        showItem: "",
        default: "employee",
        label: "visibility",
        required: true,
        view: true,
        add: true,
        update: true,
        apiType: "JSON",
        selectApi: [
          { id: "admin", value: t("admin") },
          { id: "manager", value: t("manager") },
          { id: "employee", value: t("employee") },
        ],
        filter: false,
      },
  
      {
        type: "text",
        placeholder: "Note",
        name: "note",
        validation: "",
        default: "",
        showItem: "Note",
        label: "Note",
        required: false,
        view: true,
        add: true,
        update: true,
        filter: false,
      },
      {
        type: "file",
        placeholder: "file",
        name: "file",
        validation: "",
        showItem: "",
        default: "",
        label: "file",
        required: false,
        view: false,
        add: true,
        update: true,
        filter: false,
      },
      {
        type: "checkbox",
        placeholder: "requestDocs",
        name: "requestDocs",
        validation: "",
        showItem: "",
        default: "",
        label: "requestDocs",
        required: false,
        view: false,
        tag: true,
        add: true,
        update: true,
        filter: false,
      },
    ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("documents")} - PersoBase`;
  }, [t]);
  

  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container style={{flexDirection:'column'}} className="noshadow">
      <ListTable bulkUplaod={false} {...props} api={`files`} itemTitle={`fullName`} shortName={`documents`} viewDetails={false} addPrivilege={false} delPrivilege={false} updatePrivilege={false} selectPrivilege={false} attributes={attributes} formMode="double" moreOptions={false} popUpUsingId={false} chart={false} datefilter={true} ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(EquipmentReport);
